export default __webpack_public_path__ + "static/contact-landscape-19e0619d892c06023666dae4b43ee70b.jpg";